module.exports = __webpack_public_path__ + "img/cloud_tool_stripbar.eab733ed.jpg";